"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalPreferences = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const molecules_1 = require("../../molecules");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
function AdditionalPreferences() {
    const isARKitCompatible = (0, device_1.useARKitCompatibilityStatus)();
    const { isMobile, isDesktop, isAndroid } = (0, device_1.usePlatform)();
    const isCN = (0, device_1.useIsCNRegion)();
    const systemVersion = (0, device_1.useSystemVersion)();
    const isValidVersion = isAndroid
        ? systemVersion && parseFloat(systemVersion) > 12
        : true;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'AdditionalPreferences_Title', children: (0, i18n_1.Localized)(i18n_1.Strings.settings.preferences.additionalPreferences) }), (0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'AdditionalPreferences_Container', children: [(0, jsx_runtime_1.jsx)(molecules_1.LanguageSelector, { "data-e2e": 'AdditionalPreferences_LanguageSelector' }), !!isARKitCompatible && isMobile && (0, jsx_runtime_1.jsx)(molecules_1.ARModeSwitch, { "data-e2e": 'AdditionalPreferences_ARModeSwitch' }), (0, jsx_runtime_1.jsx)(molecules_1.AutoSyncSwitch, { "data-e2e": 'AdditionalPreferences_AutoSyncSwitch' }), (0, jsx_runtime_1.jsxs)("div", { "data-e2e": 'AdditionalPreferences_div', children: [(0, jsx_runtime_1.jsx)("div", { "data-e2e": 'AdditionalPreferences_div', children: (0, jsx_runtime_1.jsx)(molecules_1.PrivacyNotificationsSwitch, { "data-e2e": 'AdditionalPreferences_PrivacyNotificationsSwitch' }) }), !isCN && !isDesktop && isValidVersion && ((0, jsx_runtime_1.jsxs)(PushContainer, { "data-e2e": 'AdditionalPreferences_PushContainer', children: [' ', (0, jsx_runtime_1.jsx)(molecules_1.PushNotificationsSwitch, { "data-e2e": 'AdditionalPreferences_PushNotificationsSwitch' }), ' '] }))] }), (0, jsx_runtime_1.jsx)(molecules_1.Full3DRotationSwitch, { "data-e2e": 'AdditionalPreferences_Full3DRotationSwitch' }), (0, jsx_runtime_1.jsx)(molecules_1.BeatingHeartSwitch, { "data-e2e": 'AdditionalPreferences_BeatingHeartSwitch' }), (0, jsx_runtime_1.jsx)(molecules_1.ModelsUpdateSwitch, { "data-e2e": 'AdditionalPreferences_ModelsUpdateSwitch' })] })] }));
}
exports.AdditionalPreferences = AdditionalPreferences;
const Title = styled_components_1.default.div `
  margin-bottom: 4px;
  margin-left: calc(24px + env(safe-area-inset-left));
  margin-left: calc(24px + constant(safe-area-inset-left));

  color: ${({ theme }) => theme.designSystem.text};
  font-size: 16px;
  line-height: 24px;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    margin-bottom: 16px;
    margin-left: 0;
  `)}
`;
const Container = styled_components_1.default.div `
  display: grid;
  grid-row-gap: 34px;
  grid-template-columns: 1fr;
  padding: 24px calc(24px + env(safe-area-inset-right)) 24px
    calc(24px + env(safe-area-inset-left));
  padding: 24px calc(24px + constant(safe-area-inset-right)) 24px
    calc(24px + constant(safe-area-inset-left));

  color: ${({ theme }) => theme.designSystem.text};
  font-size: 14px;
  line-height: 20px;

  background: ${({ theme }) => theme.designSystem.contentBackground};

  ${ui_1.device.mobileL((0, styled_components_1.css) `
    grid-auto-flow: column;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, auto);
    grid-gap: 36px 144px;
  `)}

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    padding: 28px 40px;
    border-radius: 4px;
  `)}
`;
const PushContainer = styled_components_1.default.div `
  padding-top: 40px;
`;
